import { useState } from "react";
import { useLocation, useParams } from "@remix-run/react";
import Header from "./header";
import PageIntro from "./page-intro-wrapper";
import Footer from "./footer";
import { SearchBox } from "~/shared";
import { classNames, GetScreenSize } from "~/utils";
import InklusionIntroImage from "./inklusion_background_image";
import searchBgImage from "~/assets/images/search/search-bg.svg";
import type { LinksData } from "~/api/get_static_data.server";

export default function Layout({
  children,
  title,
  subtitle,
  links,
  isLandingPage,
  hasPageIntro = true,
  hasLogo,
}: {
  children: any;
  title: string;
  subtitle: string;
  isLandingPage: boolean;
  id: string;
  hasLogo: false;
  hasPageIntro?: boolean;
  links: Array<LinksData>;
}) {
  const size = GetScreenSize();
  const { pathname } = useLocation();
  const { articleId, methodId } = useParams();
  const [query, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState<
    "medien" | "fachartikel" | "veranstaltungen"
  >("medien");
  const isDetailsPpage = articleId || methodId;

  // Determine formAction based on active tab
  const getFormAction = () => {
    if (activeTab === "fachartikel") {
      return query
        ? `/professional_article/main?q=${query}`
        : `/professional_article/main`;
    }
    return query ? `/search/main?q=${query}` : `/search/main`;
  };

  const formAction = getFormAction();

  return (
    <>
      <Header links={links} />
      <main
        id="scrollArea"
        // ref={scrollablePageDiv}
        // style={{ height: "100vh", border: "4px solid orange" }}

        className="mt-[40px] mb-20 flex-grow"
      >
        {hasPageIntro && (
          <PageIntro
            size={size}
            isLandingPage={isLandingPage}
            title={title}
            subtitle={subtitle}
            logo={hasLogo}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            searchBox={
              isLandingPage && pathname !== "/inklusion" ? (
                //@ts-ignore
                <SearchBox
                  formAction={formAction}
                  query={query}
                  setSearchQuery={setSearchQuery}
                  isLandingPage={true}
                  activeTab={activeTab}
                />
              ) : undefined
            }
          />
        )}
        {pathname === "/inklusion" && (
          <InklusionIntroImage size={size} title={title} subtitle={subtitle} />
        )}
        {(pathname.includes("/search/main") ||
          pathname.includes("/professional_article/main")) && (
          <div className="relative -z-10 hidden h-full w-full flex-col pt-0 md:flex">
            <div
              className={classNames(
                "absolute  w-full",
                isDetailsPpage ? "top-5" : "top-24"
              )}
            >
              <div className="">
                <img
                  alt=""
                  className="w-full object-bottom"
                  src={searchBgImage}
                />
              </div>
            </div>
          </div>
        )}
        {pathname.includes("/themenschwerpunkte") && (
          <div className="relative -z-10 hidden h-full w-full flex-col pt-16 md:flex">
            <div className={classNames("absolute top-6 w-full")}>
              <div className="">
                <img
                  alt=""
                  className="w-full object-bottom"
                  src={searchBgImage}
                />
              </div>
            </div>
          </div>
        )}
        {children}
      </main>
      <Footer isLandingPage={isLandingPage} links={links} />
    </>
  );
}
